<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection>
          <div class="text-right">
            <argon-button :isRouteLink="true" :to="{ name: 'Create Aspek KPI' }"><font-awesome-icon icon="fa-solid fa-plus" /> Tambah Aspek KPI</argon-button>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="pe-md-3 d-flex align-items-center w-50">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData()" type="text" class="form-control"
                      placeholder="Type here..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <list-view :thead="['Nama Aspek Penilaian', 'Nilai 1', 'Nilai 2', 'Nilai 3', 'Nilai 4', 'Nilai 5', 'Status', 'Aksi']">
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="8" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td class="font-weight-bold">{{ item.name ?? "" }}</td>
                <td v-for="index in 5" :key="index">{{ replaceRange(item, index-1) }}</td>
                <td>
                  <argon-badge v-if="item.status == 1" color="success">Aktif</argon-badge>
                  <argon-badge v-if="item.status == 0" color="danger">Non Aktif</argon-badge>
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'Update Aspek KPI', params: { id: item?.id ?? 0 } }"
                      class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                      data-original-title="Edit user">Edit</router-link>
                    <button @click.prevent="deleteData(item.id)"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                      data-original-title="Delete user">Hapus</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
            <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
          </list-view>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import AspekKinerjaApi from '@/repository/api/AspekKinerjaApi';
import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ListView from '@/components/ListView.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
export default {
  name: "tables",
  components: {
    CardComponent,
    InputGroup,
    ArgonBadge,
    ArgonButton,
    ThreeDotsMenu,
    MetaSection,
    GridRow,
    GridCol,
    ListView,
    ArgonPagination,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      params: {
        master: 1,
        keyword: "",
        page: 1,
      },
      metaData: {},
    };
  },
  async mounted() {
    await this.getData();
  },
  watch: {
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getData();
        }
      },
      deep: false,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    replaceRange(item, index) {
      let str = String(this.getRange(item)?.[index]?.split(' && ')?.[this.getRange(item)[index].split(' && ')?.length - 1] ?? "").replace('>=', ' - ').replace(/((<|>)(=?))/, ' - ');
      str = str.split(" - ")
      switch (item['nilai' + (index + 1) + '_min_operator']) {
        case '<':
          str[0] = (Number.parseFloat(str[0]) - 0.01).toFixed(2)
          break;
        case '>':
          str[0] = (Number.parseFloat(str[0]) + 0.01).toFixed(2)
          break;
      
        default:
          str[0] = Number.parseFloat(str[0]).toFixed(2)
          break;
      }
      switch (item['nilai' + (index + 1) + '_max_operator']) {
        case '<':
          str[1] = (Number.parseFloat(str[1]) - 0.01).toFixed(2)
          break;
        case '>':
          str[1] = (Number.parseFloat(str[1]) + 0.01).toFixed(2)
          break;
      
        default:
          str[1] = Number.parseFloat(str[1]).toFixed(2)
          break;
      }
      str[0] = String(str[0].toLocaleString()).replace(/\.0{1,}$/, "")
      str[1] = String(str[1].toLocaleString()).replace(/\.0{1,}$/, "")
      str = str.join(" - ")
      return str;
    },
    getRange(item) {
      let data = []
      for (let index = 1; index <= 5; index++) {
        data.push([item['nilai' + index + '_min_operator'], item['nilai' + index + '_min'], item['nilai' + index + '_max_operator'], item['nilai' + index + '_max']])
      }
      console.log(JSON.parse(JSON.stringify(data)))
      let str = []
      let temp = ""
      for (let index = 0; index < data.length; index++) {
        if (index == 0) {
          data[index].splice(0, 1)
        }
        if (index > 0) {
          // switch (data[index][0]) {
          //   case '>':
          //     data[index][1] = String(parseInt(data[index][1]) + 0.01)
          //     break;
          //   case '<':
          //     data[index][1] = String(parseInt(data[index][1]) - 0.01)
          //     break;

          //   default:
          //     break;
          // }
          data[index][1] = data[index][1] + " && " + data[index][1]
          temp = data[index].join('')
          temp = str[index - 1] + " && " + data[index - 1][data[index - 1].length - 1] + temp
        }
        else {
          temp = data[index].join('')
        }
        // if (index > 0) {
        //     temp = data[index-1][data[index-1].length - 1] + temp
        // }
        str.push(temp)
      }
      return str;
    },
    async getData() {
      Object.keys(this.params).forEach(key => {
        if (this.params[key] === undefined || this.params[key] === null) {
          delete this.params[key];
        }
      });
      clearTimeout(this.timer)
      if (this.params.keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (this.params.keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500)
      }
    },
    async getDataAll() {
      this.$store.state.loading = true;
      await AspekKinerjaApi.getbyparam(this.params).then((response) => {
        this.data = response.data;
        this.metaData = {
          status: response?.status ?? null,
          message: response?.message ?? null,
          total_item: response?.total_item ?? null,
          per_page: response?.per_page ?? null,
          total_page: response?.total_page ?? null,
          current_page: response?.current_page ?? null,
        }
      }).catch((error) => {
        if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          this.params.page = 1;
        }
        this.metaData = {};
        this.data = [];
      })
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await AspekKinerjaApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.message || 'Something wrong, please try again.',
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
